interface DeleteConfirmModalProps {
  productName: string;
  onConfirm: () => void;
  onCancel: () => void;
  deleting: boolean;
}

export default function DeleteConfirmModal({ productName, onConfirm, onCancel, deleting }: DeleteConfirmModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative bg-white rounded-2xl w-full max-w-sm p-6 flex flex-col gap-4">
        <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-full mx-auto">
          <i className="ri-delete-bin-line text-red-500 text-xl"></i>
        </div>
        <div className="text-center">
          <h3 className="text-base font-semibold text-[#1a1a1a] mb-1">确认删除</h3>
          <p className="text-sm text-[#666]">
            确定要删除商品 <strong className="text-[#1a1a1a]">「{productName}」</strong> 吗？此操作不可撤销。
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={deleting}
            className="flex-1 py-2.5 rounded-lg border border-[#e8e4de] text-sm text-[#555] hover:bg-[#f7f5f2] transition-colors cursor-pointer whitespace-nowrap"
          >
            取消
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="flex-1 py-2.5 rounded-lg bg-red-500 text-white text-sm font-semibold hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {deleting ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                删除中...
              </>
            ) : '确认删除'}
          </button>
        </div>
      </div>
    </div>
  );
}
